const FormTestPage = () => import('@/test/views/FormTestPage');

export default import.meta.env.DEV ? [
  {
    path: '/_test',
    meta: {
      public: true,
    },
    children: [
      {
        path: 'form',
        component: FormTestPage,
      },
    ],
  },
] : [];
